import { css, styled } from 'styled-components';

import { colors, h3Text } from '#/theme/theme';

export const ListingViewSectionHolder = styled.div<{ $noBorderTop: boolean }>`
  margin-top: 24px;

  ${(props) =>
    !props.$noBorderTop &&
    css`
      border-top: solid 1px ${colors.selectionGrey};
      padding-top: 24px;
    `};
`;

export const ListingViewSectionTitle = styled.h2`
  ${h3Text};
  margin-bottom: 24px;
`;
